var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 7C1.66699 3.78045 4.27413 1.16748 7.49368 1.16748C10.7191 1.16748 13.332 3.78045 13.332 7C13.332 10.2196 10.7191 12.8325 7.49368 12.8325C4.27413 12.8325 1.66699 10.2196 1.66699 7ZM2.8335 7C2.8335 9.57797 4.92154 11.666 7.49951 11.666C10.0775 11.666 12.1655 9.57797 12.1655 7C12.1655 4.42203 10.0775 2.33398 7.49951 2.33398C4.92154 2.33398 2.8335 4.42203 2.8335 7ZM6.91626 4.08374H7.79102V7.14539L10.4153 8.70245L9.97791 9.41975L6.91626 7.58276V4.08374Z",
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.7f330cd13715e6f477ba12a714d235ad.svg";
export { ForwardRef as ReactComponent };